<template>
  <v-app-bar app color="white" height="80">
    <v-toolbar-title>
      <v-avatar size="50">
        <v-img src="@/assets/PenguinAvartar.svg"></v-img>
      </v-avatar>
    </v-toolbar-title>
    <h1 class="ToolBarTitleFont ml-2">Penguintory</h1>
    <v-spacer></v-spacer>
    <v-btn rounded outlined color="#5FA1FC" dark class="ToolBarButtonFont mr-3" href="https://penguintory-alpha.web.app/">เข้าสู่ระบบ</v-btn>
    <v-btn rounded color="green" dark class="ToolBarButtonFont" href="https://penguintory-alpha.web.app/register">สมัครใช้งานฟรี</v-btn>
    <!-- <v-btn rounded color="green" dark class="ToolBarButtonFont" href="https://forms.gle/FnQLofFo7a1o1yYd8">สมัครรับข้อมูลพิเศษจากเรา</v-btn> -->
  </v-app-bar>
</template>

<script>

export default {
  name: 'NavBar',
  data() {
    return{

    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.ToolBarTitleFont{
  font-family: 'Prompt';
  font-weight: 800;
  color:black;
  font-size: 18pt;
}

.ToolBarButtonFont{
  font-family: 'Prompt';
  font-weight: 600;
}

</style>
